import http from '../_http_v2';

const dashboard = {
  //wmds
  month: (m) => { return http.get(`console/wmds/dashboard/month`, m); },
  week: (m) => { return http.get(`console/wmds/dashboard/week`, m); },
  day: (m) => { return http.get(`console/wmds/dashboard/day`, m); },
  agent: (m) => { return http.get(`console/wmds/dashboard/agent`, m); },

  status: (m) => { return http.get(`console/wmds/dashboard/status`, m); },

  //wfdetector
  monthForgery: (m) => { return http.get(`console/wmds/dashboard/month/forgery`, m); },
  weekForgery: (m) => { return http.get(`console/wmds/dashboard/week/forgery`, m); },
  agentForgery: (m) => { return http.get(`console/wmds/dashboard/agent//forgery`, m); },

}

export default dashboard

export { dashboard }